import axios from "axios"

const apiUrl = "/api/"

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}, signal = null) {
  if (!options.headers) {
    options.headers = {}
  }

  if (signal) options.signal = signal

  options.headers.Authorization = localStorage.getItem("token")
  return options
}

export default {
  employeeCourses: {
    // ===== Mitarbeiter-Kurse (User Ansicht) =====
    fetchCourses(params = {}) {
      const url = buildUrl("employee-courses")
      return axios.get(url, buildOptions({ params })).then((res) => res.data)
    },

    fetchCourse(id) {
      const url = buildUrl(`employee-courses/${id}`)
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    register(courseId) {
      const url = buildUrl(`employee-courses/${courseId}/register`)
      return axios.post(url, {}, buildOptions()).then((res) => res.data)
    },

    unregister(courseId) {
      const url = buildUrl(`employee-courses/${courseId}/unregister`)
      return axios.post(url, {}, buildOptions()).then((res) => res.data)
    },

    // ===== Für Mitglieder freigeschaltete Mitarbeiter-Kurse =====
    customer: {
      fetchCourses(date, signal = null) {
        const url = buildUrl("employee-courses/customer")
        return axios.get(url, buildOptions({ params: { date } }, signal)).then((res) => res.data)
      },

      fetchCourse(courseId) {
        const url = buildUrl(`employee-courses/customer/${courseId}`)
        return axios.get(url, buildOptions()).then((res) => res.data)
      },

      register(courseId) {
        const url = buildUrl(`employee-courses/customer/${courseId}/register`)
        return axios.post(url, {}, buildOptions()).then((res) => res.data)
      },

      unregister(courseId) {
        const url = buildUrl(`employee-courses/customer/${courseId}/unregister`)
        return axios.post(url, {}, buildOptions()).then((res) => res.data)
      },
    },

    fetchActiveFormats() {
      const url = buildUrl("employee-courses/formats")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },

    // ===== Admin & Management Ansicht =====
    admin: {
      fetchCourses(params = {}) {
        const url = buildUrl("employee-courses/admin")
        return axios.get(url, buildOptions({ params })).then((res) => res.data)
      },

      downloadSchedulePdf(from, to, filename = "Mitarbeiterkurse_Einsatzplan.pdf") {
        const url = buildUrl("employee-courses/admin/schedule-pdf")
        return axios
          .get(url, {
            params: { from, to },
            responseType: "blob",
            headers: { Authorization: localStorage.getItem("token") },
          })
          .then((response) => {
            const blob = response.data
            if (window.flutter_inappwebview) {
              return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = function () {
                  const base64 = String(reader.result).split(",")[1]
                  if (!base64) return reject(new Error("PDF konnte nicht gelesen werden."))
                  Promise.resolve(
                    window.flutter_inappwebview.callHandler("blobToBase64Handler", base64, "pdf", filename.replace(/\.pdf$/i, "")),
                  ).then(resolve, reject)
                }
                reader.onerror = function () {
                  reject(reader.error || new Error("PDF konnte nicht gelesen werden."))
                }
                reader.readAsDataURL(blob)
              })
            } else {
              const downloadUrl = URL.createObjectURL(blob)
              const a = document.createElement("a")
              a.href = downloadUrl
              a.download = filename
              document.body.appendChild(a)
              a.click()
              a.remove()
              setTimeout(() => URL.revokeObjectURL(downloadUrl), 5000)
            }
          })
      },

      createCourse(data) {
        const url = buildUrl("employee-courses/admin")
        return axios.post(url, data, buildOptions()).then((res) => res.data)
      },

      updateCourse(id, data) {
        const url = buildUrl(`employee-courses/admin/${id}`)
        return axios.put(url, data, buildOptions()).then((res) => res.data)
      },

      deleteCourse(id) {
        const url = buildUrl(`employee-courses/admin/${id}`)
        return axios.delete(url, buildOptions()).then((res) => res.data)
      },

      fetchRegistrations(courseId) {
        const url = buildUrl(`employee-courses/admin/${courseId}/registrations`)
        return axios.get(url, buildOptions()).then((res) => res.data)
      },

      fetchUserDetails(userId) {
        const url = buildUrl(`employee-courses/admin/user/${userId}`)
        return axios.get(url, buildOptions()).then((res) => res.data)
      },

      manualRegister(courseId, userId) {
        const url = buildUrl(`employee-courses/admin/${courseId}/manual-register`)
        return axios.post(url, { userId }, buildOptions()).then((res) => res.data)
      },

      cancelRegistration(courseId, registrationId) {
        const url = buildUrl(`employee-courses/admin/${courseId}/registrations/${registrationId}/cancel`)
        return axios.post(url, {}, buildOptions()).then((res) => res.data)
      },

      // Course Formats management
      fetchFormats() {
        const url = buildUrl("employee-courses/admin/formats")
        return axios.get(url, buildOptions()).then((res) => res.data)
      },

      createFormat(data) {
        const url = buildUrl("employee-courses/admin/formats")
        return axios.post(url, data, buildOptions()).then((res) => res.data)
      },

      updateFormat(id, data) {
        const url = buildUrl(`employee-courses/admin/formats/${id}`)
        return axios.put(url, data, buildOptions()).then((res) => res.data)
      },
    },
  },
}
